module.exports = __webpack_public_path__ + "./Serene_5c67be487773573949ad140ff0b95031.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2019/Serene.jpg
// module id = 486
// module chunks = 0